<script>
  /* import getHelpers, { cssPrefix } from '../helper-classes.js'
   * export let helperClass = ''
   * const classes = []
   * if (helperClass) classes.push(...getHelpers(helperClass)) */
</script>

<span><slot /></span>
